module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2024_en-a9649d21a88cf58412be39972873d281.jpg";